module.exports = __webpack_public_path__ + "img/bg_chess_05.586147ca.jpg";